'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import { useGlobalConfigContext } from '../../global-config'
import { loginRegistrationGtmPushFullStoryPayLoad } from '../gtm/events/loginRegistrationGtmPushFullStoryPayLoad'

export const useLoginRegistrationGtmPushFullStoryTracking = (
  open?: boolean,
): void => {
  const pathName = usePathname()
  const config = useGlobalConfigContext()

  useEffect(() => {
    loginRegistrationGtmPushFullStoryPayLoad({
      config,
      isModalOpen: open,
      pathName,
    })
  }, [config, open, pathName])
}
